import { ga4Track, navigationEvent } from '@unisporkal/ga4';

angular.module('landingPage').controller('GettyNavBarTracking', [
  '$scope',
  function ($scope) {
    $scope.trackNavBar = (event, text) => {
      const href = event.currentTarget.getAttribute('href');
      const ga4Event = navigationEvent({
        link_text: text,
        link_url: href,
        navigation_selection: text,
        ui_element_location: 'landing_page_category_tabs',
      });
      ga4Track(ga4Event);
    };

    $scope.trackVideoNavBar = (event, text) => {
      const href = event.currentTarget.getAttribute('href');
      const ga4Event = navigationEvent({
        link_text: text,
        link_url: href,
        navigation_selection: 'video',
        ui_element_location: 'landing_page_subcategory_tabs',
      });
      ga4Track(ga4Event);
    };

    $scope.trackEditorialFootageDropdown = (event, text) => {
      const href = event.currentTarget.getAttribute('href');
      const ga4Event = navigationEvent({
        link_text: text,
        link_url: href,
        navigation_selection: 'video',
        ui_element_location: 'landing_page_subcategory_tabs_editorial_footage',
      });
      ga4Track(ga4Event);
    };
  },
]);
